// The block's <script> tag is re-executed whenever product-info swaps <main>, so the
// definition has to be guarded or the second run throws.
if (!customElements.get('pdp-tabs')) {

class PdpTabs extends HTMLElement {
    connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.pdp-tabs__tab'));
        this.panels = Array.from(this.querySelectorAll('.pdp-tabs__panel'));

        if (this.tabs.length === 0) return;

        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index), { signal });
            tab.addEventListener('keydown', (event) => this.onKeydown(event, index), { signal });
        });
    }

    disconnectedCallback() {
        this.controller?.abort();
    }

    select(index, { focus = true } = {}) {
        this.tabs.forEach((tab, i) => {
            const isActive = i === index;
            tab.classList.toggle('active', isActive);
            tab.setAttribute('aria-selected', isActive);
            tab.tabIndex = isActive ? 0 : -1;
            this.panels[i]?.classList.toggle('active', isActive);
        });

        if (focus) this.tabs[index].focus();

        this.refreshChildren(this.panels[index]);
    }

    onKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next = null;

        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;

        if (next === null) return;

        event.preventDefault();
        this.select(next);
    }

    // Sliders inside a hidden panel measure themselves as zero-width, so refresh them
    // once the panel becomes visible.
    refreshChildren(panel) {
        panel?.querySelectorAll('swiper-container').forEach((slider) => slider.swiper?.update());
    }
}

customElements.define('pdp-tabs', PdpTabs);

}
